import Model, { attr } from '@ember-data/model';

interface TotalGivenExpectingReportModelData {
  pledges: {
    expected?: {
      pledge_id: string;
      expected_amount: number;
      expected_gifts_count: number;
    }[];
    overdue?: {
      pledge_id: string;
      expected_amount: number;
      expected_gifts_count: number;
    }[];
  };
  start_date: string;
  expected_amount: number;
  expected_percent: number;
  given_amount: number;
  given_percent: number;
  overdue_amount: number;
  overdue_percent: number;
  left_amount: number;
  left_percent: number;
  total_amount: number;
  total_percent: number;
}

export default class TotalGivenExpectingReportModel extends Model {
  @attr('number') goalAmount!: number;
  @attr('date-only') goalDate!: Date;
  @attr() data?: TotalGivenExpectingReportModelData;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'total-given-expecting-report': TotalGivenExpectingReportModel;
  }
}
